(function () {
  class KhelspaceMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
      this.dialog.addEventListener('close', () => this.afterClose());
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), summary')].filter(element => element.getClientRects().length > 0);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
      this.desktop = window.matchMedia('(min-width: 1025px)');
      this.onResize = event => { if (event.matches) this.close(); };
      this.desktop.addEventListener('change', this.onResize);
      this.setExpanded(false);
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.onResize);
      if (this.dialog?.open) this.close();
    }
    setExpanded(open) {
      document.querySelectorAll('[data-side-drawer="#Drawer-Menu"] button').forEach(button => {
        button.setAttribute('aria-controls', this.id);
        button.setAttribute('aria-expanded', String(open));
        if (!open) button.classList.remove('active');
      });
    }
    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger;
      this.hadBodyLock = document.body.classList.contains('overflow-hidden');
      this.hadHtmlLock = document.documentElement.hasAttribute('scroll-lock');
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
      document.documentElement.setAttribute('scroll-lock', '');
      this.setExpanded(true);
    }
    close() {
      if (this.dialog.open) this.dialog.close();
    }
    afterClose() {
      if (!this.hadBodyLock) document.body.classList.remove('overflow-hidden');
      if (!this.hadHtmlLock) document.documentElement.removeAttribute('scroll-lock');
      this.setExpanded(false);
      requestAnimationFrame(() => {
        if (!this.dialog.open && this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      });
    }
  }
  if (!customElements.get('ksm-mobile-menu')) customElements.define('ksm-mobile-menu', KhelspaceMobileMenu);
})();
